import Image from 'react-bootstrap/Image';
import topTitle from './images/topTitle_sm.svg';
import topMessage from './images/topMessage.svg';
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const Home = () => {
    return (
      <>
        <motion.div
          animate={{
            x: 0,
            opacity: 1
          }}
          initial={{
            x: 100,
            opacity: 0
          }}
          exit={{
            x: -100,
            opacity: 0
          }}
          transition={{
            duration: 0.2
          }}
        >
          <main>
            <Image src={topTitle} alt="母の日に、感謝を伝えよう！" fluid />

            <p className="lead my-5">
              5/8は母の日。<br />
              心温まる仏言に<br />
              あなたのメッセージを添えて、<br />
              日頃の感謝の気持ちを<br />
              伝えてみませんか？
            </p>

            <div className="text-center my-5">
                ・<br />
                ・<br />
                ・<br />
            </div>

            <img src={topMessage} alt="心から愛しているということを、伝えなさい。伝え切りなさい。" className="img-fluid" />

            <div className="text-center my-5">
                ・<br />
                ・<br />
                ・<br />
            </div>

            <div className="my-5">
              <Link className="btn btn-warning btn-lg" to="/mothersday2022/choose"> やってみる </Link>
            </div>
          </main>
  
        </motion.div>
      </>
    );
  }
